<template>
  <div class="fling-controller">
    <div class="header">
      <div class="date">{{ today }}</div>
      <div v-if="token" class="store">{{ token.location }}</div>
    </div>

    <!-- valid sesson -->
    <template v-if="token">
      <div class="content">
        <div class="scroll-window">
          <div class="logo"></div>
          <div v-for="(channel, index) in activeChannels" :key="index" class="button" @click="broadcast(channel.value)">{{ channel.name }}</div>
        </div>
      </div>
      <div class="footer">
        <div class="button-return" @click="broadcast('close')">Go Back To Regular Program</div>
      </div>
    </template>

    <!-- invalid sesson -->
    <template v-else>
      <div class="fling-connect-container">
        <input :maxlength="pinLength" placeholder="" v-model="pin" />
        <div class="message">
          <div class="message-title">To enable the Fling Controller please scan the <span>QR Code</span> or enter the <span>{{ pinLength }} digit pin</span> on the target device</div>
        </div>
      </div>
    </template>

  </div>
</template>

<script>

import { channels } from '../js/channels';

export default {
  name: 'FlingController',
  computed: {
    today() {
      const today = new Date();
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      return today.toLocaleDateString('en-US', options);
    },
    activeChannels() { return channels.filter(c => c.enabled); }
  },
  async mounted() {
    // IF we can't restore the session, check the url for a device code
    if(!(this.$services.fling.restoreLocalSession() && await this.setSessionToken())) {
      let pathParts = document.location.pathname.split('/');
      if (pathParts.length > 1) {
        let _token = pathParts[pathParts.length-1];
        if (_token && _token.length === this.pinLength) {
          this.pin = _token;
          this.authorize();
        }
      }
    }
  },
  data() {
    return {
      token: null,
      controller: null,
      pin: '',
      pinLength: 6,
    };
  },
  watch: {
    token(val) {
      if (val) this.validateSession();
      else this.$services.fling.authorized();
    },
    pin() {
      if (this.pin.length === this.pinLength) this.authorize();
    },
  },
  methods: {
    resetPin() {
      this.pin = '';
    },
    authorize() {
      this.$services.fling.authorizeByDeviceCode(this.pin, {
        onErr: (resp) => console.log('e ', resp),
        onSuccess: (resp) => {
          this.token = resp.data;
        }
      });
      this.pin = '';
    },
    broadcast(val) {
      const payload = { 'content': val };
      this.$log.debug('broadcast', val);
      this.$services.fling.broadcast(payload, {
        onErr: () => this.token = null,
      });
    },
    validateSession() {
      if (!this.token) return;
      let authEnd = new Date(`${this.token.expiresAt} ${this.token.tz}`);
      let myDate = new Date;
      if(myDate < authEnd) {
        this.$log.debug('Session Poll: Valid');
        window.setTimeout(this.validateSession, 1000);
        return;
      }
      this.$log.debug('Session Poll: Invalid... redirecting');
      this.token = null;
    },
    async setSessionToken() {
      let response = await this.$services.fling.authorized({
        onSuccess: (resp) => {
          this.token = resp.data;
          this.$log.debug('Router: setSessionToken - Session Token Retrieved');
        }
      });

      return response.data.status === 'Success';
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .fling-controller {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: $general-color-white;
    color: $general-color-white;

    display: flex;
    flex-direction: column;

    .header {
      width: 100%;
      height: 60px;
      min-height: 60px;
      position: relative;
      background-color: $general-color-black;
      font-size: 16px;
      display: flex;
      align-items: center;
      padding: 0 15px;
      box-shadow: 0 0 8px rgb(0, 0, 0, 0.5);

      .date {
        height: 60%;
        flex-grow: 1;
        padding-right: 25px;
        display: flex;
        align-items: center;
      }

      .store {
        height: 60%;
        padding-left: 25px;
        border-left: 1px solid $brand-color-main;
        display: flex;
        align-items: center;
      }
    }

    .content {
      width: 100%;
      height: auto;
      position: relative;
      flex-grow: 1;
      overflow-y: scroll;

      .scroll-window {
        width: 100%;
        height: auto;
        position: relative;
        padding: 0 20px;

        display: flex;
        flex-direction: column;
        align-items: center;

        .logo {
          width: 120px;
          height: 50px;
          position: relative;
          background-image: url(../assets/hub-spot-logo.svg);
          background-size: cover;
          margin: 30px 0;
        }

        .button {
          width: 100%;
          max-width: 300px;
          height: 50px;
          position: relative;
          padding: 0 20px;
          background-color: $button-button-color-main;
          text-transform: uppercase;
          text-align: center;
          cursor: pointer;

          display: flex;
          align-items: center;
          justify-content: center;

          margin-bottom: 20px;

          &:hover {
            background-color: $button-button-color-main-hover;
          }
        }
      }
    }

    .fling-connect-container {
      width: 100%;
      height: 100%;
      position: relative;

      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .message {
        width: 100%;
        height: auto;
        padding: 20px;
        margin-top: 20px;
        position: relative;
        

        .message-title {
          font-size: 20px;
          text-align: center;
          position: relative;
          color: $general-color-black;

          span {
            color: $brand-color-main;
          }

        }
      }

      input {
        width: 100%;
        height: 60px;
        max-width: 240px;
        border: solid 4px $brand-color-main;
        border-radius: 5px;
        font-size: 30px;
        font-weight: 700;
        text-transform: uppercase;
        text-align: center;
        color: $general-color-black;

        outline-color: transparent !important;
        outline-style: none !important;
        -webkit-appearance: none !important;
      }
    }

    .footer {
      width: 100%;
      height: 50px;
      min-height: 50px;
      position: relative;
      padding: 0 20px;

      box-shadow: 0 0 8px rgb(255, 255, 255, 0.5);

      display: flex;
      align-items: center;
      justify-content: center;

      .button-return {
        width: 100%;
        max-width: 260px;
        height: 100%;
        padding: 0 20px;
        font-size: 14px;
        background-color: hsl(0, 0%, 40%);
        text-transform: uppercase;
        text-align: center;
        cursor: pointer;

        display: flex;
        align-items: center;
        justify-content: center;

      }
    }
  }
</style>
